<script>
import CustomButton from '@/components(new)/UI/Buttons/CustomButton/CustomButton.vue'
import { dicionario } from '@/libs/utils/forms/dicionario.js'

export default {
  components: {
    CustomButton
  },
  props: {
    objeto: {
      type: Object,
      required: true
    },
    deletar: {
      type: Function,
      required: false,
      default: null
    },
    editar: {
      type: Function,
      required: false,
      default: null
    },
    titulo: {
      type: String,
      required: false,
      default: null
    },
    widthCard: {
      type: String,
      required: false,
      default: '380px'
    }
  },
  data () {
    return {
      dicionario
    }
  },

  methods: {
    // Se a label tiver acento ou ç, deve ser adicionada no dicionario.js;
    // Caso contrário vai adicionar espaços onde for camelcase e colocar a primeira letra em maiúscula automaticamente;
    formataLabel (key) {
      if (dicionario[key]) return dicionario[key]
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
    }
  }
}
</script>

<template>
  <div class="m-2">
    <el-card :style="{ width: widthCard }">
      <div v-if="titulo">
        <h3 class="titulo">{{ titulo }}</h3>
        <hr>
      </div>
      <div class="cards">
        <div>
          <p v-for="(key, index) in Object.keys(this.objeto)" :key="index" v-if="objeto[key]">
            {{ formataLabel(key) }}: {{ objeto[key] }}
          </p>
        </div>
        <div class="actionButtons">
          <CustomButton
            v-if="deletar"
            type="ErrorButton"
            icon="fa fa-trash"
            @click="deletar"
          />
          <CustomButton
            v-if="editar"
            icon="fa fa-pencil-alt"
            @click="editar"
          />
        </div>
      </div>
    </el-card>
  </div>
</template>

<style lang="scss">
@import '@/scss/_mixins.scss';

.titulo {
  margin: 0;
}

.cards {
  display: flex;
  justify-content: space-between;
}

.actionButtons {
  @include column-flex;
  justify-content: center;
  gap: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Cards/Card/Card.vue